export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://skillapi.bluekaktus.co/api';

export const config = {
    apiBaseUrl: API_BASE_URL,
};
